import React from 'react';
import { Text, FlexColumn } from '@make-software/tg-mini-app-ui';
import Lottie from 'lottie-react';

import { IHackathonProject, IVoteRank } from '@/entities';
import loadingAnimation from '@/shared/assets/lottie/loading-animation.json';

import { HackathonProjectCard } from '../hackathon-project-card';

interface ProjectsListProps {
  projects: IHackathonProject[];
  loading: boolean;
  error: Error | null | string;
  onProjectClick: (documentId: string) => void;
  voteRanking: IVoteRank[];
}

export const ProjectsList: React.FC<ProjectsListProps> = ({
  projects,
  loading,
  error,
  onProjectClick,
  voteRanking
}) => {
  const hasProjects = projects && projects.length > 0;

  if (!hasProjects && loading) {
    return (
      <FlexColumn justify="center" align="center" style={{ alignSelf: 'center' }}>
        <Lottie animationData={loadingAnimation} style={{ height: 220, width: 220 }} loop />
      </FlexColumn>
    );
  }

  if (error) {
    return (
      <FlexColumn>
        <Text weight={2} size="md" color="#FFFFFF" fontFamily="Inter" fontWeight={700}>
          Failed to load projects. Please try again.
        </Text>
      </FlexColumn>
    );
  }

  return (
    <FlexColumn>
      {projects.map((project) => {
        const voteRank = voteRanking?.find((v) => v.project_address === project?.project_hash);

        return (
          <HackathonProjectCard
            key={project.id}
            project={project}
            onClick={() => onProjectClick(project.documentId)}
            voteRank={voteRank}
          />
        );
      })}


      {loading && hasProjects && (
        <FlexColumn justify="center" align="center" style={{ alignSelf: 'center', marginTop: 16 }}>
          <Lottie animationData={loadingAnimation} style={{ height: 80, width: 80 }} loop />
        </FlexColumn>
      )}
    </FlexColumn>
  );
};
